<template>
    <div class="app">
        <scroll v-pull="refresh">
            <no-record :condition="visitInfo" tips='暂无就诊记录'></no-record>
            <section class="thick" v-for="(treatItem, index) in visitInfo.treatItems">
                <div class="panel">就诊序号&nbsp;
                    <span class="f-strong">{{index + 1 | formatNum}}</span>
                </div>
                <div class="row arr-row table-row">
                    <div class="col">
                        <span class="f-minor">就诊日期</span>&nbsp;&nbsp;<span
                            class="f-minor">{{treatItem.treatDate | formatDate}}</span>
                    </div>
                    <div class="col">
                        <button @click.stop="goVisitDetail(index)" class="btn-minor-blue btn-position">查看</button>
                    </div>
                </div>
            </section>
        </scroll>
    </div>
</template>
<script>
import recordService from 'record.service'
import NoRecord from 'NoRecord';
export default {
    components: {
        NoRecord
    },
    data() {
        return {
            visitInfo: {
                "totalNum": 0,
                "treatItems": [
//                    {
//                        "treatDate": "2017-11-12 20:20:20",
//                        "hospital": "彭州市人民医院",
//                        "treatType": "门诊",
//                        "deptName": "呼吸科",
//                        "doctName": "张医师",
//                        "chiefComplaint": "咳嗽",
//                        "treatName": "咽喉炎",
//                        "treatId": "201601010005"
//                    },
//                    {
//                        "treatDate": "2017-11-12",
//                        "hospital": "彭州市人民医院",
//                        "treatType": "门诊",
//                        "deptName": "呼吸科",
//                        "doctName": "张医师",
//                        "chiefComplaint": "咳嗽",
//                        "treatName": "咽喉炎",
//                        "treatId": "201601010006"
//                    },
//                    {
//                        "treatDate": "2017-11-12",
//                        "hospital": "彭州市人民医院",
//                        "treatType": "门诊",
//                        "deptName": "呼吸科",
//                        "doctName": "张医师",
//                        "chiefComplaint": "咳嗽",
//                        "treatName": "咽喉炎",
//                        "treatId": "201601010007"
//                    }
                ]
            },
            curPage: 1
        }
    },
    created() {
        this.refresh();
    },
    methods: {
        refresh() {
            var voucher = this.$store.state.paramModule.param.healthRecord.voucher;
            recordService.getVisit({cardNo: voucher.cardNo, cardType: voucher.cardType, curPage: this.curPage}).then((res) => {
                if (res.treatItems.length > 0) {
                    this.visitInfo.treatItems = this.visitInfo.treatItems.concat(res.treatItems);
                    this.curPage = this.curPage + 1;
                }
            });
        },

        goVisitDetail(index) {
            this.visitInfo.treatItems[index].index = index + 1;
            this.$store.commit('updateParam', {
                namespace: 'healthRecord',
                treatItem: this.visitInfo.treatItems[index],
            });
            this.$router.push('visitRecordDetail');
        },
    }
}
</script>


// WEBPACK FOOTER //
// VisitRecord.vue?5562c98c